<template>
    <div class="classic-form-page">
        <mdb-view>
            <div class="pg_login__title">
                Вас приветствует корпоративный сайт<br>
                Системы Менеджмента Качества ООО «TEMIRYO’L-SUG’URTA»
            </div>
            <mdb-mask class="justify-content-center align-items-center d-lg-flex">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="pg_login__hero">
                            <img :src="require('../../assets/tys_logo_white.svg')" alt="">
                        </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="pg_login__content">
                                <div class="pg_login__heading pg_login__heading--mobile">Вас приветствует корпоративный сайт Системы Менеджмента<br>
                                    Качества ООО «TEMIRYO’L-SUG’URTA»</div>
                                <div class="pg_login__heading pg_login__heading--desktop">Для входа в систему, пожалуйста, авторизуйтесь</div>
                                 <form class="pg_login__form login needs-validation log_forrm" novalidate @submit.prevent="checkForm" >

                            <h3 class="text-center text-uppercase">Войти:</h3>
                                     <div class="errorMSG">{{ error }}</div>
                                         <div class="md-form">
                                              <i class="fas prefix fa-user"></i>
                                             <input type="text" 
                                                    class="form-control loginInput"
                                                    id="validationCustom01"
                                                    placeholder="Логин"
                                                    v-model.trim="username"
                                                    required>
                                             <div class="invalid-feedback emptyInput">
                                                 Пожалуйста введите что-нибудь
                                             </div>
                                         </div>


                                         <div class="md-form">
                                             <i class="fas prefix fa-lock"></i>
                                             <input type="password"
                                                    class="form-control PasswordInput"
                                                    id="validationCustom02"
                                                    placeholder="Пароль"
                                                    v-model.trim="password"
                                                    required>
                                             <div class="invalid-feedback emptyInput">
                                                 Пожалуйста введите что-нибудь
                                             </div>
                                         </div>

                            <div class="text-right mt-4 black-text">
                                <mdb-btn type="submit" color="primary">Войти</mdb-btn>
                            </div>
                        </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pg_login__iso-logo">
                    <img :src="require('../../assets/iso_logo_cropped.jpg')" alt="">
                </div>
            </mdb-mask>
        </mdb-view>
    </div>
</template>

<script>

    import {
        mdbView,
        mdbMask,
        mdbBtn,
    } from "mdbvue";

    export default {
        name: "Login",
        components: {
            mdbView,
            mdbMask,
            mdbBtn,
        },
        data() {
            return {
                username : "",
                password : "",
                error: '',
             };
        },
        methods: {
            checkForm(event) {
                event.preventDefault();
                event.target.classList.add('was-validated');
                if (this.username !== '' && this.password !== ""){
                    this.login()
            }
                return this.login
            },
            login: function () {
                let username = this.username
                let password = this.password
                this.$store.dispatch('login', { username, password })
                    .then(() => this.$router.push('/'))
                    .catch(err =>{
                        this.error = this.$store.getters.error
                        console.log(err)
                    })
            }
        },
    };
</script>

<style scoped>
     .emptyInput{
         margin-left: 40px;
     }
     .loginInput{
         border: none;
         border-radius: 0;
         border-bottom: 1px solid rgba(128, 128, 128, 0.29);
         padding: 0;
         margin-left: 15px;
         width: 90%;
     }
      .PasswordInput{
          border: none;
          border-bottom: 1px solid rgba(128, 128, 128, 0.43);
          border-radius: 0;
          padding: 0;
          margin-left: 15px;
          width: 90%;
      }

    .errorMSG{
        display: flex;
        margin-bottom: 10px;
        justify-content: center;
        color: red;
        font-size: 16px;
    }

    .classic-form-page {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10000;
        height: 100vh;
        width: 100%;
    }

    .classic-form-page .view {
        background: rgb(0,110,180);
        height: 100vh;
    }
    .classic-form-page h6 {
        line-height: 1.7;
    }

    .pg_login__hero{
        box-sizing: border-box;
        text-align: center;
    }
    .pg_login__hero img{
        display: inline;
    }
    .pg_login__content{
        box-sizing: border-box;
    }
    .pg_login__form{
        margin: 0 auto;
        width: 480px;
        max-width: 100%;
        padding: 15px;
        box-sizing: border-box;
        background: white;
        color: black;
        border-radius: 8px;
    }
    .pg_login__heading {
        margin: 0 auto;
        width: 480px;
        max-width: 100%;
        padding: 15px;
        text-align: center;
        font-size: 20px;
        color: white;
    }
    .pg_login__title{
        color: white;
        text-align: center;
        font-weight: bold;
        margin-top: 50px;
        font-size: 25px;
    }
    .pg_login__heading--mobile{
        display: none;
    }
    .pg_login__iso-logo{
        width: 100px;
        position: absolute;
        bottom: 8px;
        left: 8px;
    }
    @media (max-width: 991px){
        .pg_login__hero{
            width: 200px;
            margin-top: 20px;
        }
        .pg_login__content{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }
        .pg_login__heading{
            width: 280px;
            font-size: 18px;
            padding: 5px;
            line-height: 1.4;
        }
        .pg_login__heading--mobile {
            display: block;
        }
        .pg_login__form{
            width: 280px;

        }

        .pg_login__title, .pg_login__heading--desktop{
            display: none;
        }
        .pg_login__iso-logo{
            width: 60px;
        }

    }

</style>
